import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-input-utility/dist/es6.js';
import spartaInputErrorUtility from '@sparta.global.utilities/sparta-input-error-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaValidationFramework from '@sparta.global.utilities/sparta-validation-framework-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import { select } from '@sparta.global.helpers/select-helper/dist/es6.js';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "		<form novalidate>\r\n			<div class=\"large-8 large-centered medium-10 small-12 medium-centered column\">\r\n				<div class=\"row calc-content-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"leftContent") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":5},"end":{"line":63,"column":14}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"rightContent") : depth0),{"name":"with","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":5},"end":{"line":102,"column":14}}})) != null ? stack1 : "")
    + "				</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"footerContent") : depth0),{"name":"with","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":104,"column":4},"end":{"line":116,"column":13}}})) != null ? stack1 : "")
    + "			</div>\r\n		</form>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "						<div class=\"small-12 medium-6 large-4 column left-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"with","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":7},"end":{"line":16,"column":16}}})) != null ? stack1 : "")
    + "              <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":9},"end":{"line":35,"column":18}}})) != null ? stack1 : "")
    + "              </div>\r\n              <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputsHidden") : depth0),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":9},"end":{"line":42,"column":18}}})) != null ? stack1 : "")
    + "              </div>\r\n			  <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputsFalls") : depth0),{"name":"each","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":9},"end":{"line":60,"column":18}}})) != null ? stack1 : "")
    + "              </div>\r\n						</div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"row\">\r\n  								<div class=\"small-12 column title\">\r\n  									<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n  								</div>\r\n                </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  								<div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":19,"column":22},"end":{"line":19,"column":87}}})) != null ? stack1 : "")
    + " column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","CURRENCY-TYPE",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":11},"end":{"line":22,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","SELECT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":11},"end":{"line":25,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","ZIP-TYPE",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":11},"end":{"line":28,"column":22}}})) != null ? stack1 : "")
    + "  								</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":10},"end":{"line":34,"column":17}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    return "large-10 small-10";
},"8":function(container,depth0,helpers,partials,data) {
    return "small-12";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  										"
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":21,"column":12},"end":{"line":21,"column":32}}})) != null ? stack1 : "")
    + "\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  										"
    + ((stack1 = (lookupProperty(helpers,"select")||(depth0 && lookupProperty(depth0,"select"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"select","hash":{},"data":data,"loc":{"start":{"line":24,"column":12},"end":{"line":24,"column":29}}})) != null ? stack1 : "")
    + "\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  									<div class=\"medium-2 small-2 column\">\r\n  										"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n  									</div>\r\n";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  								<div class=\"small-12 column inputs-hidden\">\r\n  									"
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":40,"column":11},"end":{"line":40,"column":31}}})) != null ? stack1 : "")
    + "\r\n  								</div>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  								<div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":46,"column":22},"end":{"line":46,"column":87}}})) != null ? stack1 : "")
    + " column\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","CURRENCY-TYPE",{"name":"ifCond","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":11},"end":{"line":52,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","SELECT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":11},"end":{"line":55,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","ZIP-TYPE",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":11},"end":{"line":58,"column":22}}})) != null ? stack1 : "")
    + "  								</div>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"preText") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":12},"end":{"line":50,"column":17}}})) != null ? stack1 : "")
    + "  										"
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":51,"column":12},"end":{"line":51,"column":32}}})) != null ? stack1 : "")
    + "\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "											<div class=\"preText\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"preText") : depth0), depth0))
    + "</div>\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "						<div class=\"small-12 medium-6 large-4 column right-content\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"with","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":66,"column":7},"end":{"line":72,"column":16}}})) != null ? stack1 : "")
    + "              <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inputs") : depth0),{"name":"each","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":74,"column":9},"end":{"line":91,"column":18}}})) != null ? stack1 : "")
    + "              </div>\r\n              <div class=\"row\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"labels") : depth0),{"name":"each","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":94,"column":9},"end":{"line":99,"column":18}}})) != null ? stack1 : "")
    + "              </div>\r\n						</div>\r\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <div class=\"row\">\r\n  							<div class=\"small-12 column title\">\r\n  								<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n  							</div>\r\n              </div>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  								<div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":75,"column":22},"end":{"line":75,"column":87}}})) != null ? stack1 : "")
    + " column loan-options\">\r\n"
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","CURRENCY-TYPE",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":76,"column":11},"end":{"line":78,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","SELECT-TYPE",{"name":"ifCond","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":79,"column":11},"end":{"line":81,"column":22}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"ifCond")||(depth0 && lookupProperty(depth0,"ifCond"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"==","ZIP-TYPE",{"name":"ifCond","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":11},"end":{"line":84,"column":22}}})) != null ? stack1 : "")
    + "  								</div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":86,"column":10},"end":{"line":90,"column":17}}})) != null ? stack1 : "");
},"26":function(container,depth0,helpers,partials,data) {
    return "medium-10 small-9";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  									<div class=\"medium-2 small-3 column\">\r\n  										"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"optionalLink") : depth0), depth0)) != null ? stack1 : "")
    + "\r\n  									</div>\r\n";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  								<div class=\"small-12 column "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\">\r\n  									<p>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n  									<p id='"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "-id'>"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"text") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n  								</div>\r\n";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "					<div class=\"row\">\r\n						<div class=\"small-12 text-center column button-container\">\r\n							<a class=\"spa-btn spa-btn--primary spa-btn--expand-on-small spa-btn--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"size") : stack1), depth0))
    + "\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"href") : stack1), depth0))
    + "\" id=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"id") : stack1), depth0))
    + "-small\" data-submit-text-change ="
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"data-submit-text-change") : stack1), depth0))
    + " role=\"button\">\r\n								<span class=\"button-text\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"button") : depth0)) != null ? lookupProperty(stack1,"placeholder") : stack1), depth0))
    + "</span>\r\n								<span class=\"ada-hidden\"></span><span class=\"spin\"></span>\r\n							</a>\r\n						</div>\r\n						<div class=\"small-12 large-7 large-centered column disclaimer-container\">\r\n							<p class=\"data-xsmall\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"disclaimer") : depth0), depth0)) != null ? stack1 : "")
    + "</p>\r\n						</div>\r\n					</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"closingCostsDataMappingPayload\" data-jcr=\""
    + container.escapeExpression((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"dataMappingPayload") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":1,"column":51},"end":{"line":1,"column":80}}}))
    + "\"></div>\r\n\r\n<section class=\"row calculator-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":4,"column":1},"end":{"line":119,"column":10}}})) != null ? stack1 : "")
    + "</section>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

/* eslint-disable import/prefer-default-export */
/**
 * Handlebars Helpers: closing-costs-calculator-module
 */

/**
 * @param {String} v1 v1?
 * @param {String} operator math operator
 * @param {String} v2 v2?
 * @param {Object} options options obj
 * @returns {void}
 */
function ifCond(v1, operator, v2, options) {
  switch (operator) {
    case '==':
      return v1 == v2 ? options.fn(this) : options.inverse(this);
    // eslint-disable-line
    case '===':
      return v1 === v2 ? options.fn(this) : options.inverse(this);
    case '<':
      return v1 < v2 ? options.fn(this) : options.inverse(this);
    case '<=':
      return v1 <= v2 ? options.fn(this) : options.inverse(this);
    case '>':
      return v1 > v2 ? options.fn(this) : options.inverse(this);
    case '>=':
      return v1 >= v2 ? options.fn(this) : options.inverse(this);
    case '&&':
      return v1 && v2 ? options.fn(this) : options.inverse(this);
    case '||':
      return v1 || v2 ? options.fn(this) : options.inverse(this);
    default:
      return options.inverse(this);
  }
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/closing-costs-calculator-module",
  "version": "3.0.1",
  "id": "closingCostsCalculatorModule",
  "containerID": "homeLoansClosingCostsCalculatorModule",
  "moduleName": "home-loans-closing-costs-calculator-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "closingCostsCalculatorModule",
  "data": {
    "init": "closingCostsCalculatorModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        ifCond,
        select,
        textInput,
        json
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    ifCond,
    select,
    textInput,
    json
  },
  "dependencies": {
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/select-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-input-error-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-input-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.6",
    "@sparta.global.utilities/sparta-validation-framework-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0"
  },
  "stores": []
};

// This is acutally used

/**
 * @export
 * @class closingCostsCalculatorModule
 * @extends {Module}
 */
class closingCostsCalculatorModule extends Module {
  /**
   * Constructor for module JS.
   * @param {Object} options module opts
   * @param {context} context module context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#closingCostsCalculatorModule');
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
    this.globalVars = {
      dataMappingPayload: ''
    };
  }

  /**
   * @method enableDisableInputByLoadType
   * @desc based on loan term option disable or enable loan type
   * @return {void}
   */
  enableDisableInputByLoadType() {
    const downPaymentSelect = this.$target.find('#down-payment-select');
    const selection = this.$target.find('#loan-term-select');
    const loadType = this.$target.find('#loan-type-select');
    if (selection.val() === '30 years' && loadType.val() === 'Fixed rate') {
      downPaymentSelect.html(`
    <option value="3%">3%</option>
    <option value="3.5%">3.5%</option>
    <option value="4%">4%</option>
    <option value="4.5%">4.5%</option>
    <option value="5%">5%</option>
    <option value="10%">10%</option>
    <option value="15%">15%</option>
    <option value="20%" selected="selected">20%</option>
    <option value="25%">25%</option>
    <option value="30%">30%</option>`);
    } else {
      downPaymentSelect.html(`
    <option value="5%" selected="selected">5%</option>
    <option value="10%">10%</option>
    <option value="15%">15%</option>
    <option value="20%">20%</option>
    <option value="25%">25%</option>
    <option value="30%">30%</option>`);
    }
  }

  /**
   * @method enableDisableLoanTypeInput
   * @param {Object} e event object
   * @return {void}
   * @desc based on loan term option disable or enable loan type
   */
  enableDisableLoanTypeInput(e) {
    const $cache = this.$target.find(e.currentTarget);
    // get parent container
    const parentContainer = $cache.closest('div[class*=content]');

    // get selected val
    const selection = $cache.val();

    // ensure we have data hide input type attribute
    // which tells us to disable or enable the select box
    if ($cache.attr('data-hide-input-type')) {
      // figure out selected value of loan term we will show or hide loan type
      let inputHide = $cache.attr('data-hide-input-type');

      // ensure we don't have any spaces after the comma then split
      inputHide = inputHide.replace(/(,)(\s+)(\w+)/g, '$1$3').split(',');
      // loan type select
      const loanTypeSelect = parentContainer.find('#loan-type-select');
      const downPaymentSelect = this.$target.find('#down-payment-select');
      const loadType = this.$target.find('#loan-type-select');
      if (selection === '30 years' && loadType.val() === 'Fixed rate') {
        downPaymentSelect.html(`
        <option value="3%">3%</option>
        <option value="3.5%">3.5%</option>
        <option value="4%">4%</option>
        <option value="4.5%">4.5%</option>
        <option value="5%">5%</option>
        <option value="10%">10%</option>
        <option value="15%">15%</option>
        <option value="20%" selected="selected">20%</option>
        <option value="25%">25%</option>
        <option value="30%">30%</option>`);
      } else {
        downPaymentSelect.html(`
        <option value="5%" selected="selected">5%</option>
        <option value="10%">10%</option>
        <option value="15%">15%</option>
        <option value="20%">20%</option>
        <option value="25%">25%</option>
        <option value="30%">30%</option>`);
      }

      // if loan term selected is in array then disable select
      if (inputHide.indexOf(selection) > -1) {
        loanTypeSelect.focusin();
        loanTypeSelect.val('Fixed rate').prop('disabled', true).addClass('select-disabled');
        loanTypeSelect.closest('.spa-input').addClass('select-disabled');
        loanTypeSelect.closest('.spa-input').next('.input-help').addClass('input-help-margin');
      } else {
        // if loan term selected is NOT in array then re-enable select
        loanTypeSelect.prop('disabled', false).removeClass('select-disabled');
        loanTypeSelect.closest('.spa-input').removeClass('select-disabled');
        loanTypeSelect.closest('.spa-input').next('.input-help').removeClass('input-help-margin');
      }

      // focus out on loan type so it removes green color
      loanTypeSelect.focusout();
    }
  }

  /**
   * @method populateDefaultSelections
   * @return {void}
   * @desc update selection to default values from jcr
   */
  populateDefaultSelections() {
    const $cache = this.$target.find('select[data-default-selection]');
    $cache.each((idx, val) => {
      const $selection = $(val);
      const dataField = $selection.attr('data-default-selection');

      // trigger change in case we have an event on change
      $selection.val(dataField).trigger('change');
      // trigger focus in to ensure sparta input text goes to upper left
      // and then focus out to remove green color
      $selection.focusin().focusout();
    });
  }

  /**
   * @method cleanupInputs
   * @param {String} inp input string
   * @return {String} cleaned up input
   */
  cleanupInputs(inp = '') {
    // strip anything but character, number, or .
    return inp.replace(/[^0-9.]/g, '');
  }

  /**
   * @method formatPrice
   * @param {String} inp input string
   * @return {String} formatted price
   */
  formatPrice(inp) {
    return inp.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace('.00', '');
  }

  /**
   * @method validateDownPayment
   * @return {Boolean} is valid
   */
  validateDownPayment() {
    const $downaPaymentValue = this.$target.find('#down-payment-select');
    const $loanTermSelect = this.$target.find('#loan-term-select');
    const $loanTypeSelect = this.$target.find('#loan-type-select');
    const $purchasePriceInput = this.$target.find('#grossInputField');
    const toCalculateValidation = $loanTypeSelect.val() === 'Fixed rate' && $loanTermSelect.val() === '30 years';
    if (!toCalculateValidation) {
      const newLabel = $purchasePriceInput.siblings('label');
      newLabel.parents('.spa-input').parent().hide();
      const field = {
        field: $downaPaymentValue,
        label: $downaPaymentValue.siblings('label')
      };
      spartaInputErrorUtility.updateInlineError(false, field);
      return true;
    }
    const data = Number($downaPaymentValue.val().replace('%', ''));
    const amount = Number($purchasePriceInput.val().replace(',', ''));
    const $label = $downaPaymentValue.siblings('label');
    if (data < 5 && amount <= 0) {
      const newLabel = $purchasePriceInput.siblings('label');
      newLabel.parents('.spa-input').parent().show();
      newLabel.html(newLabel.html().replace('*', ''));
      newLabel.html(newLabel.html().replace('income', 'income *'));
      const message = 'Select a down payment at least 5% of purchase price or enter income';
      const msg2 = 'Enter income or go back and select a down payment at least 5% of purchase price';
      spartaInputErrorUtility.updateInlineError(true, {
        field: $downaPaymentValue,
        label: $label,
        message
      });
      spartaInputErrorUtility.updateInlineError(true, {
        field: $purchasePriceInput,
        label: newLabel,
        message: msg2
      });
      $purchasePriceInput.siblings('.spa-input-label').addClass('spa-error-form-label--validation');
      return false;
    } else {
      //eslint-disable-line
      const newLabel = $purchasePriceInput.siblings('label');
      if (data >= 5) {
        newLabel.html(newLabel.html().replace('*', ''));
      }
      const field = {
        field: $downaPaymentValue,
        label: $downaPaymentValue.siblings('label')
      };
      const field2 = {
        field: $purchasePriceInput,
        label: newLabel
      };
      spartaInputErrorUtility.updateInlineError(false, field);
      spartaInputErrorUtility.updateInlineError(false, field2);
      $purchasePriceInput.siblings('.spa-input-label').removeClass('spa-error-form-label--validation');
      if (data >= 20) {
        newLabel.parents('.spa-input').parent().hide();
      } else {
        newLabel.parents('.spa-input').parent().show();
      }
      return true;
    }
  }

  /**
   * @param {Boolean} validateAll validate all ?
   * @returns {Object} calculated amount
   */
  calculateDownpaymentAndLoanAmount(validateAll = false) {
    const $cache = this.$target;
    let validated = false;
    let purchasePrice = $cache.find('#purchase-price-input').val();
    purchasePrice = Number(this.cleanupInputs(purchasePrice));
    let downpaymentPercentage = $cache.find('#down-payment-select').val();
    downpaymentPercentage = this.cleanupInputs(downpaymentPercentage);
    const downPayment = Math.ceil(purchasePrice * (downpaymentPercentage / 100));
    const totalLoanAmount = purchasePrice - downPayment;
    $cache.find('#down-payment-input-hidden').val(`$${this.formatPrice(downPayment)}`);
    const purchasePriceInputHidden = $cache.find('#loan-amount-input-hidden');
    purchasePriceInputHidden.val(`$${this.formatPrice(totalLoanAmount)}`);
    const postalCode = Number($cache.find('#zip-code-input').val().slice(0, 5));
    const {
      validationCore
    } = this;
    if (validateAll === true) {
      const $requiredInputs = $cache.find('input[required]');
      if ($requiredInputs) {
        const allRequiredValuesProvided = validationCore.validateRequiredFields($requiredInputs);
        const $inputs = $cache.find('input[data-validation-rules]');
        // eslint-disable-next-line array-callback-return, consistent-return
        const validationResults = $inputs && $inputs.map((idx, input) => {
          const $input = $(input);
          if ($input && this.validationRules[$input.attr('id')].change) {
            return validationCore.validateRules($input, this.validationRules[$input.attr('id')].change);
          }
        });
        const grossInputValidation = this.validateDownPayment();
        validated = allRequiredValuesProvided && _.every(validationResults) && grossInputValidation;
      }
    } else {
      const $input = $cache.find('#loan-amount-input-hidden');
      validationCore.validateRules($input, this.validationRules[$input.attr('id')].change);
    }
    let grossInputField = $cache.find('#grossInputField').val();
    grossInputField = Number(this.cleanupInputs(grossInputField));
    return {
      purchasePrice,
      downpaymentPercentage,
      downPayment,
      totalLoanAmount,
      purchasePriceInputHidden,
      postalCode,
      validated,
      grossInputField
    };
  }

  /**
   * @returns {void}
   */
  calculatorValidate() {
    const $cache = this.$target;
    const objReturn = this.calculateDownpaymentAndLoanAmount(true);
    const {
      purchasePrice,
      downpaymentPercentage,
      downPayment,
      totalLoanAmount,
      validated,
      postalCode,
      grossInputField
    } = objReturn;

    // figure out what data product name we need to pass to pub event
    const {
      dataMappingPayload
    } = this.globalVars;

    // get loan term/type
    const loanTermSelect = $cache.find('#loan-term-select option:selected').text();
    const loanTypeSelect = $cache.find('#loan-type-select option:selected').text();

    // determine product
    let mappingProduct = _.find(dataMappingPayload, {
      loanTerm: loanTermSelect,
      loanType: loanTypeSelect
    });
    if (mappingProduct) {
      mappingProduct = mappingProduct.productName || '';
    } else {
      mappingProduct = '';
    }
    const annualIncome = grossInputField > 0 ? grossInputField : undefined;

    // if we pass all checks then pub event
    if (validated) {
      const obj = {
        purchasePrice,
        amountBorrowed: totalLoanAmount,
        downPayment,
        downpaymentPercentage,
        postalCode,
        mappingProduct,
        debtToIncomeInputs: {
          annualIncome,
          monthlyDebt: 0
        }
      };
      this.Events.pub('HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT', {
        rateInputs: obj
      });
    } else {
      this.addParsleyOutlineErrorOnInputTextField();
    }
  }

  /**
   * @returns {void}
   */
  updateButtonText() {
    // update button to appropriate text
    const $cache = this.$target;
    const recalculateText = $cache.find('.spa-btn').attr('data-submit-text-change') || null;
    if (recalculateText) {
      $cache.find('.spa-btn .button-text').text(recalculateText);
    }
  }

  // This method trigger parsley to add its error outline on input text field
  /**
   * @returns {void}
   */
  addParsleyOutlineErrorOnInputTextField() {
    const $cache = this.$target;
    const $form = $cache.find('form');
    $form.find('input[type="tel"]').each(function inputEach() {
      $(this).focus();
      $(this).focusout();
    });
    // Set the focus back on purchase price
    $cache.find('#purchase-price-input').focus();
  }

  /**
   * @returns {void}
   */
  updateSpinner() {
    this.$target.find('.spin').toggleClass('spinner');
  }

  /**
   * @param {Object} response object
   * @returns {void}
   */
  failureRates(response) {
    const payload = response.data;
    // if 400 then only update error messages on client side (don't show rates fallback)
    response = JSON.parse(payload.responseText); // eslint-disable-line
    const arr = response.fieldErrors;
    const zipValid = arr.find(a => a.fieldId === 'rateInputs.postalCode');
    const purchasePriceValid = arr.find(a => a.fieldId === 'rateInputs.purchasePrice');
    const amountBorrwedValid = arr.find(a => a.fieldId === 'rateInputs.amountBorrowed');
    let message = '';

    // zip code validation
    const $zipInput = this.$target.find('#zip-code-input');
    const $zipLabel = $zipInput.siblings('label');
    if (zipValid) {
      [, message] = zipValid.message.split('|');
      spartaInputErrorUtility.updateInlineError(true, {
        field: $zipInput,
        label: $zipLabel,
        message
      });
    } else {
      spartaInputErrorUtility.updateInlineError(false, {
        field: $zipInput,
        label: $zipLabel
      });
    }
    // purchase price validation
    const $purchasePrice = this.$target.find('#purchase-price-input');
    const $priceLabel = $purchasePrice.siblings('label');
    if (purchasePriceValid) {
      [, message] = purchasePriceValid.message.split('|');
      spartaInputErrorUtility.updateInlineError(true, {
        field: $purchasePrice,
        label: $priceLabel,
        message
      });
    } else {
      spartaInputErrorUtility.updateInlineError(false, {
        field: $purchasePrice,
        label: $priceLabel
      });
    }
    // amount borrowed validation
    const $loanAmountInput = this.$target.find('#loan-amount-input-hidden');
    const $loanAmountLabel = $loanAmountInput.siblings('label');
    if (amountBorrwedValid) {
      [, message] = amountBorrwedValid.message.split('|');
      spartaInputErrorUtility.updateInlineError(true, {
        field: $loanAmountInput,
        label: $loanAmountLabel,
        message
      });
    } else {
      spartaInputErrorUtility.updateInlineError(false, {
        field: $loanAmountInput,
        label: $loanAmountLabel
      });
    }
  }

  /**
   * @returns {void}
   */
  ratesSuccess() {
    // update button text
    this.updateButtonText();

    // fade out failure
    this.fadeOutFallback();

    // scroll to module
    this.scrollSuccess();
  }

  /**
   * @param {Object} response response obj
   * @returns {void}
   */
  ratesFailure(response) {
    const {
      status
    } = response.data;
    // 400 then fade out fallback and show server side messages
    if (status === 400) {
      this.fadeOutFallback();
      this.failureRates(response);
    } else if (status === 500) {
      // completely bad response then fade in fallback and scroll to it
      this.fadeInFallback();
      this.scrollFailure();
    } else if (status === 200) {
      // possibility we can get a failure ajax but a 200 (if bad json) then show fallback
      this.fadeInFallback();
      this.scrollFailure();
    } else if (status === 0 || !status) {
      // server is down or we forced a custom error where we don't get a response
      this.fadeInFallback();
      this.scrollFailure();
    }
  }

  /**
   * @returns {void}
   */
  fadeInFallback() {
    $('#closingCostsFallbackModule').fadeIn({
      duration: 200,
      easing: 'linear'
    });
    this.updateSpinner();
  }

  /**
   * @returns {void}
   */
  fadeOutFallback() {
    $('#closingCostsFallbackModule').fadeOut({
      duration: 200,
      easing: 'linear'
    });
    this.updateSpinner();
  }

  /**
   * @param {Number} height height num
   * @returns {void}
   */
  animateToPosition(height) {
    $('html, body').animate({
      scrollTop: height
    }, {
      duration: 1000
    });
  }

  /**
   * @returns {void}
   */
  scrollSuccess() {
    // sleep until rates module is hidden (just in case it's shown)
    setTimeout(() => {
      const height1 = $('#detailedInformationAboutLoanModule').offset().top || 0;
      const height2 = $('#titleModule').height() || 0;
      let height3 = 60;
      // minimize let height3 if getMoreInformationOnClosingCosts presented on page
      const getMoreInfoModule = $('#getMoreInformationOnClosingCosts');
      if (getMoreInfoModule) {
        height3 = 20;
      }
      if ($('.tab-nav-module').hasClass('active')) {
        this.animateToPosition(height1 - height2 - height3);
      } else {
        this.animateToPosition(height1 - height2);
      }
    }, 300);
  }

  /**
   * @returns {void}
   */
  scrollFailure() {
    const height1 = $('#closingCostsFallbackModule').offset().top || 0;
    const height2 = $('#titleModule').height() || 0;
    let height3 = 60;
    // minimize let height3 if getMoreInformationOnClosingCosts presented on page
    const getMoreInfoModule = $('#getMoreInformationOnClosingCosts');
    if (getMoreInfoModule) {
      height3 = 20;
    }
    if ($('.tab-nav-module').hasClass('active')) {
      this.animateToPosition(height1 - height2 - height3);
    } else {
      this.animateToPosition(height1 - height2);
    }
  }

  /**
   * @returns {void}
   */
  fadeInHeaderModules() {
    const $fadeIn = $('#small-tab-nav, #large-tab-nav');
    const $titleFadeIn = $('#titleModule');
    $fadeIn.fadeIn({
      duration: 1000,
      easing: 'linear'
    });
    if ($titleFadeIn[0].style.display === 'block') {
      $titleFadeIn.fadeIn({
        duration: 1000,
        easing: 'linear'
      });
    }
  }

  /**
   * @returns {void}
   */
  getDataMappingPayloadThenRemove() {
    const $cache = this.$target.find('#closingCostsDataMappingPayload');
    const dataMappingPayload = JSON.parse($cache.attr('data-jcr'));
    // save to global var
    this.globalVars.dataMappingPayload = dataMappingPayload;
    // remove from dom
    $cache.remove();
  }

  /**
   * @returns {void}
   */
  initializeSpartaValidationRules() {
    const validationRules = this.validationRules = _.fromPairs(this.$target.find('[data-validation-rules]').map(function () {
      // eslint-disable-line
      const $this = $(this);
      return [[$this.attr('id'), $this.data('validation-rules')]];
    }));
    const validationCore = this.validationCore = spartaValidationFramework.fn.core; // eslint-disable-line
    validationCore.bindValidationRules(validationRules, true);

    // separate handling of "required" validations
    this.$target.find('input[required]').each(function inputEach() {
      const $input = $(this);
      $input.on('blur', () => {
        if (!$input.val()) {
          validationCore.validateRequiredFields($input);
        }
      });
    });
  }

  /**
   * @returns {void}
   */
  init() {
    // fade in header modules like title module
    this.fadeInHeaderModules();
    this.getDataMappingPayloadThenRemove();

    // remove data-default-pattern on inputs
    Utility.inputRemovePatternDataAttr(this.$target);

    // Start up sparta global inputs
    this.$target.spartaInputs({
      validate: true
    });

    // initialize sparta red october validation rules
    this.initializeSpartaValidationRules();

    // on loan term select figure out to disable or enable loan type select
    this.$target.find('select#loan-term-select').on('change', this.enableDisableLoanTypeInput);
    this.$target.find('select#loan-type-select').on('change', this.enableDisableInputByLoadType);

    // on page load select default specified for select boxes
    this.populateDefaultSelections();

    // on calculate button enter in down payment and total loan amount
    this.$target.find('.spa-btn').on('click', this.calculatorValidate);
    const $downPaymentInput = this.$target.find('#down-payment-input-hidden');
    $downPaymentInput.siblings('.spa-input-hint, .spa-input-error-message').remove();

    // calculate down payment and loan amount on blur, for purchase price
    this.$target.find('#purchase-price-input').on('blur', this.calculateDownpaymentAndLoanAmount);

    // calculate down payment and loan amount on change, for down payment
    this.$target.find('#down-payment-select').on('change', this.calculateDownpaymentAndLoanAmount);

    // validate dropdown
    this.$target.find('#down-payment-select').on('change', this.validateDownPayment);
    this.validateDownPayment({
      target: {
        value: this.$target.find('#down-payment-select').val()
      }
    });
    this.$target.find('select#loan-term-select').on('change', this.validateDownPayment);
    this.$target.find('select#loan-type-select').on('change', this.validateDownPayment);
    this.$target.find('#grossInputField').on('change', this.validateDownPayment);
    this.Events.sub('HOME_LOANS_CLOSING_COST_CALCULATOR_SUBMIT', this.updateSpinner);
    this.Events.sub('HOME_LOANS_CLOSING_COST_RATES_REQUEST_SUCCESS', this.ratesSuccess.bind(this));
    this.Events.sub('HOME_LOANS_CLOSING_COST_RATES_REQUEST_FAILURE', this.ratesFailure.bind(this));
  }
}
registerModuleClass({
  moduleClass: closingCostsCalculatorModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { closingCostsCalculatorModule as default, moduleConfig };
